<div class="match-row-header desktop">
  <image-loader-utils [url]="__fixture.IsoName" [isFlags]="true" extraClasses="flag-rounded"></image-loader-utils>&nbsp;&nbsp;{{ __fixture.TournamentName }}
</div>
<div class="match-row-header mobile">
  <div class="match-row-container mobileheader">
    <div class="match-row-match-info" style="border-right: 0px !important">
      <image-loader-utils [url]="__fixture.IsoName" [isFlags]="true" extraClasses="flag-rounded"></image-loader-utils>&nbsp;&nbsp;{{ __fixture.TournamentName }}
    </div>
    <div class="match-row-details"></div>
  </div>
</div>
<div *ngFor="let dnm of __fixture.eEvents; let i = index">
  <match-r (addOdd)="clickOddUP($event)" [_selectedOdds]="_selectedOdds" [_d]="dnm" [oddType]="oddType" [_sportName]="_sportName" [_activeOddType]="oddTypes"></match-r>
</div>
